import { useUser } from '../../contexts/UserContext';

export function CTA() {
  const { openLogin } = useUser();

  return (
    <section className="py-20 bg-[#F6F8FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-[#24292F] sm:text-4xl">
            Ready to streamline your engineering onboarding?
          </h2>
          <p className="mt-4 text-lg text-[#57606A] max-w-2xl mx-auto">
            Join thousands of software engineers who are accelerating their codebase understanding with FirstCommit.
          </p>
          <div className="mt-8">
            <button 
              onClick={openLogin}
              className="h-11 px-6 bg-gray-900 text-white rounded-xl hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-base font-medium"
            >
              Start Your Free Trial
            </button>
          </div>
        </div>
      </div>
    </section>
  );
} 